export default __webpack_public_path__ + "static/media/icon_project_etc.bb203ace.svg";